const getReferralSmsDisplayConfig = (record) => {
  const displayState = record.referral_sms_display_state;
  const status = record.referral_sms_status;

  if (displayState === 'failed' || (!displayState && record.has_failed_sms_messages)) {
    return {
      iconColor: 'red',
      tooltipTitle: 'This record has one or more failed SMS messages',
    };
  }

  if (displayState === 'submit_failed' || (!displayState && record.has_sms_submit_failures)) {
    return {
      iconColor: 'red',
      tooltipTitle: 'This record has one or more SMS submit failures',
    };
  }

  if (displayState === 'in_progress' || (!displayState && record.has_in_progress_sms_messages)) {
    return {
      iconColor: '#faad14',
      tooltipTitle: 'This record has one or more SMS messages in progress',
    };
  }

  if (displayState === 'sent' || (!displayState && ['sent', 'delivered'].includes(status))) {
    return {
      iconColor: '#52c41a',
      tooltipTitle: `SMS Sent on ${record.referral_sms_sent_at} by ${record.referral_sms_sent_by}`,
    };
  }

  return {
    iconColor: undefined,
    tooltipTitle: undefined,
  };
};

export default getReferralSmsDisplayConfig;
